<template>
    <flex-layout>
        <FaqCategoryModal />
        <page-header heading="Faq Category" action="Add" toggle="offcanvas" target="#offcanvasCreate" :guard="this.$route.meta.guard"
            @click="setCreateForm" />

        <FaqCategoryTable :tableHeading="tableHeading" />
    </flex-layout>
</template>

<script>
import FlexLayout from "@/components/Layout/FlexLayout.vue";
import FaqCategoryTable from "@/components/FaqCategory/table.vue";
import PageHeader from "@/components/Utility/PageHeader.vue";
import FaqCategoryModal from "@/components/FaqCategory/modal.vue";
export default {
    name: "FaqCategory",
    components: {
        // AbsoluteLayout,
        PageHeader,
        FlexLayout,
        FaqCategoryTable,
        FaqCategoryModal
    },
    data() {
        return {
            tableHeading: [
                {
                    heading: "Title",
                },
                {
                    heading: "Slug",
                },
                {
                    heading: "Status",
                },
            ],
        };
    },
    methods: {
        setCreateForm() {
            this.$root.$emit('CREATE');
        },
    }
};
</script>
